// Due to us using Weblate, we should stick to using sv (official language code) instead of se,
// but its only needed for folder structure and not the actual language code in code, for simplicity.
import shared from '@hex/calculators-shared/locales/sv/shared.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const defaultNS = 'shared';
export const resources = { se: { shared } } as const;

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  resources,
  debug: true,
  lng: 'se',
  fallbackLng: 'se',
  ns: ['shared'],
  defaultNS,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
